import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { fetchMyClinicRole, isVeterinarianRole } from "@/lib/team/role";

/**
 * Hook to check if current user is a veterinarian in the current clinic.
 * Returns true if:
 * - User has role "veterinary" (veterinarian role), OR
 * - User has `is_veterinarian = true` in `user_clinic_access` for the current clinic (admin flagged as veterinarian)
 */
export function useIsVeterinarian() {
  return useQuery({
    queryKey: ["is-veterinarian"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      // Get current clinic to find clinic context
      const { data: profile } = await supabase
        .from("profiles")
        .select("current_clinic_id")
        .eq("id", user.id)
        .single();

      if (!profile?.current_clinic_id) {
        return false; // No clinic selected, cannot be veterinarian
      }

      return isVeterinarianRole(await fetchMyClinicRole(profile.current_clinic_id));
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
